import { render } from "./ListInvites.vue?vue&type=template&id=5ad464a3&ts=true"
import script from "./ListInvites.vue?vue&type=script&lang=ts"
export * from "./ListInvites.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Special/ListInvites.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ad464a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ad464a3', __exports__)) {
    api.reload('5ad464a3', __exports__)
  }
  
  module.hot.accept("./ListInvites.vue?vue&type=template&id=5ad464a3&ts=true", () => {
    api.rerender('5ad464a3', render)
  })

}


export default __exports__